/* eslint-disable camelcase */
import React from 'react';
import {
  Tab, Col, Nav, NavItem, Row, Button
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as authActionCreators from '../../redux/modules/auth';
import SessionList from '../../components/session/list/index';
import { info } from '../../helpers/Alert';

class Security extends React.Component {
  constructor(props) {
    super(props);

    this.sessionClose = this.sessionClose.bind(this);
  }

  componentWillMount() {
    const { sessionLists } = this.props;

    sessionLists();
  }

  sessionClose(sessionID) {
    const { sessionClose, session_lists } = this.props;

    sessionID = session_lists;

    if (Array.isArray(sessionID) && sessionID.length <= 0) {
      info('Açık olan herhangi bir oturum bulunamadı!');
    } else {
      sessionClose(sessionID);
    }
  }

  render() {
    const { session_lists } = this.props;

    return (
      <div className="security-page">
        <Tab.Container id="security-tab" defaultActiveKey="login-operations">
          <Row className="clearfix">
            <Col sm={3} className="security-menu">
              <Nav bsStyle="pills" stacked>
                <NavItem eventKey="login-operations">
                                    Giriş İşlemleri
                </NavItem>
              </Nav>
            </Col>
            <Col sm={9} className="security-content">
              <Tab.Content animation>
                <Tab.Pane eventKey="login-operations">
                  <p className="security-p">
                                        Aşağıda giriş işlemleriniz listelenmektedir.
                    {' '}
                    <br />
                                        Eğer kendiniz olmadığını düşünüyorsanız lütfen oturumları
                                        sonlandırın.
                  </p>
                  {
                                        session_lists.length > 0
                                          ? (
                                            <div style={{ margin: '20px 20px 0px 20px' }}>
                                              <Button
                                                bsStyle="danger"
                                                onClick={() => { this.sessionClose(); }}
                                                className="session-close-btn"
                                                style={{
                                                  width: 'auto',
                                                  padding: '10px',
                                                  borderRadius: '5px',
                                                  fontSize: '12px',
                                                }}
                                              >
                                                        Tüm oturumları sonlandır
                                              </Button>
                                            </div>
                                          )
                                          : null
                                    }
                  <SessionList
                    sessionLists={session_lists}
                    sessionClose={this.sessionClose}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  session_lists: state.auth.sessionLists,
});
const mapDispatchToProps = dispatch => bindActionCreators(
  { ...authActionCreators }, dispatch);
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Security));



// WEBPACK FOOTER //
// ./src/pages/security/index.js